<template>
  <div class="category-edit-page scrollable">
    <div class="page-header">
      <h1>{{ $route.meta.title }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'category' }">
          Category
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="edit-form">
      <el-form
          :model="formData"
          status-icon
          :rules="rulesValidate"
          ref="categoryEditForm"
          label-width="135px"
          class="demo-ruleForm"
      >
        <el-form-item label="Name" prop="name">
          <el-input
              type="text"
              v-model="formData.name"
              autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="Slug" prop="slug">
          <el-input
              type="textarea"
              v-model="formData.slug"
          ></el-input>
          <button class="go-to-page-button" @click="redirectToLink" style="cursor: pointer;">GO TO PAGE</button>
        </el-form-item>

        <el-form-item label="Description" prop="description">
          <el-input
              type="textarea"
              v-model="formData.description"
              autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="SEO Title" prop="seo_title">
          <el-input
              v-model="formData.seo_title"
              placeholder="Enter title for SEO"
          ></el-input>
        </el-form-item>

        <el-form-item label="SEO Description" prop="seo_description">
          <el-input
              type="textarea"
              v-model="formData.seo_description"
              placeholder="Enter description for SEO"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('categoryEditForm')"
          >Save
          </el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'

export default {
  name: 'CategoryEdit',
  data () {
    return {
      urlRequest: '',
      formData: {
        id: '',
        name: '',
        seo_title: '',
        seo_description: '',
      },
      rulesValidate: {
        name: [
            {
              required: true,
              message: 'Please input Category name. Name unique',
              trigger: 'blur'}
        ],
        slug: [
          {
            validator: this.validateSlug,
            trigger: 'blur'
          }
        ],
        seo_title: [
          {required: true, message: 'Please, input seo title!', trigger: 'blur'},
        ],
        seo_description: [
          {required: true, message: 'Please, input seo description!', trigger: 'blur'},
        ],
      },
    }
  },
  computed: {
    ...mapGetters({
      category: 'category/getShowCategory',
    }),
  },

  created () {
    if (this.$route.params.id) {
      this.$store.dispatch('category/getShowCategory', this.$route.params.id)
    } else {
      this.$store.dispatch('category/clearCurrentCategory')
    }
  },
  watch: {
    category(newCategory) {
      if (newCategory) {
        this.formData = newCategory;
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.$route.params.id) {
            console.log();
            this.$store.dispatch('category/createCategory', this.formData).then((resp) => {
              this.$router.push({name:"category"})
            })
          } else {
            this.$store.dispatch('category/updateCategory', this.formData)
          }
        } else {
          Message({
            message: 'Form not validated',
            type: 'error',
            duration: 5 * 1000,
          })
          console.log('error submit!!')
          return false
        }
      })
    },
    redirectToLink() {
      window.open(`${process.env.VUE_APP_MAIN_SITE}/blog/category/${this.formData.slug}`);
    },
    validateSlug(rule, value, callback) {
      const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
      if (!slugPattern.test(value)) {
        callback(new Error('Slug must be in a valid link format (lowercase, hyphens allowed)'));
      } else {
        callback();
      }
    },
  },
}
</script>

<style lang="scss">
  @import '../../../../assets/scss/category-edit';
</style>
